export default "__VITE_ASSET__CykifeJo__"